module.exports = __webpack_public_path__ + "assets/images/extra_man3.49b86e48b86236fdcf3d812b4e765fd1.svg";